<script>
import appConfig from "@src/app.config";

export default {
  name: "app",
  page: {
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    handleIcon() {
      if (appConfig.empresa == "sisloc") {
        const favicon = document.getElementById("favicon");
        favicon.href =
          "https://sisloc.com/wp-content/uploads/2021/03/favicon.ico";
      }

      if (this.user.clientes != undefined) {
        if (this.user.clientes.length > 0) {
          const favicon = document.getElementById("favicon");
          favicon.href = "https://www.ageradora.com.br/favicon.ico";
        }
      }
    }
  },
  created() {
    this.handleIcon();
  },
  mounted() {
    //this.handleIcon();
  }
};
</script>

<template>
  <div id="app">
    <div class="nprogress"></div>
    <RouterView :key="$route.fullPath" />
  </div>
</template>

<style lang="scss">
@import "@design";
</style>
